export default __webpack_public_path__ + "static/G3-ALPHA-b3ad784115df0255b6c68d08e71b3902.webm";